var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.4 17.7307L18.85 10.2507C19.0304 10.1739 19.1842 10.0457 19.2923 9.88211C19.4004 9.71854 19.4581 9.52679 19.4581 9.33072C19.4581 9.13464 19.4004 8.94289 19.2923 8.77932C19.1842 8.61574 19.0304 8.48756 18.85 8.41071L1.4 0.930714C1.2489 0.864808 1.08377 0.837557 0.919509 0.851417C0.755246 0.865277 0.597018 0.919813 0.459098 1.01011C0.321179 1.1004 0.207908 1.22361 0.129505 1.36861C0.0511009 1.51362 0.010031 1.67587 0.00999999 1.84071L0 6.45071C0 6.95071 0.37 7.38071 0.87 7.44071L15 9.33072L0.87 11.2107C0.37 11.2807 0 11.7107 0 12.2107L0.00999999 16.8207C0.00999999 17.5307 0.74 18.0207 1.4 17.7307Z",
    fill: "#FCFCFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendLogo);
export default __webpack_public_path__ + "static/media/send-logo.dcef516321809ea4b3be169e34c2e37e.svg";
export { ForwardRef as ReactComponent };